import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { DiagnosticsService } from './diagnostics.service';

/**
 * Registra cada llamada HTTP (método, url, status, duración) en el diagnóstico,
 * para adjuntarlo al reportar un problema.
 */
export const diagnosticsInterceptor: HttpInterceptorFn = (req, next) => {
  // No registrar el propio envío del reporte para evitar ruido/bucles.
  if (req.url.includes('/support/tickets')) return next(req);
  const diag = inject(DiagnosticsService);
  const start = performance.now();
  return next(req).pipe(
    tap({
      next: (ev) => {
        if (ev instanceof HttpResponse) {
          diag.recordNetwork(req.method, req.urlWithParams, ev.status, performance.now() - start);
        }
      },
      error: (err) => {
        diag.recordNetwork(req.method, req.urlWithParams, err?.status ?? 0, performance.now() - start);
      },
    }),
  );
};
